import { api } from "../../../utils/api";
import { TOKEN } from "../../../utils/localStorage";
import { getCookie } from "cookies-next";

// Vessel Master API

export const getVesselMastersListApi = async (data) => {
  return await api.get(
    `/vessel/list?active=${data?.active}&searchByName=${
      data?.searchByFirstName
    }${data?.limit ? `&limit=${data?.limit}` : ""}${
      data?.offset.toString() ? `&offset=${data?.offset}` : ""
    }`,
    {
      headers: {
        Authorization: `Bearer ${getCookie(TOKEN)}`,
      },
    }
  );
};

export const addVesselMastersListApi = async (data) => {
  return await api.post(`/vessel/create`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const updateVesselMastersListApi = async (data) => {
  return await api.put(`/vessel/${data?.id}`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const deleteVesselMastersListApi = async (id) => {
  return await api.delete(`/vessel/${id}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

// Vessel Type Master API

export const getVesselTypeMastersListApi = async (data) => {
  return await api.get(
    `/vessel-type/list?active=${data?.active}&searchByName=${
      data?.searchByFirstName
    }${data?.limit ? `&limit=${data?.limit}` : ""}${
      data?.offset.toString() ? `&offset=${data?.offset}` : ""
    }`,
    {
      headers: {
        Authorization: `Bearer ${getCookie(TOKEN)}`,
      },
    }
  );
};

export const addVesselTypeMastersListApi = async (data) => {
  return await api.post(`/vessel-type/create`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const updateVesselTypeMastersListApi = async (data) => {
  return await api.put(`/vessel-type/update/${data?.id}`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const deleteVesselTypeMastersListApi = async (id) => {
  return await api.delete(`/vessel-type/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

// Checklist Master and Checklist Question API

export const getChecklistMastersListApi = async (data) => {
  return await api.get(
    `/checklist/list?checklist_type=${data?.checklist_type}${
      data?.limit ? `&limit=${data?.limit}` : ""
    }${data?.offset.toString() ? `&offset=${data?.offset}` : ""}`,
    {
      headers: {
        Authorization: `Bearer ${getCookie(TOKEN)}`,
      },
    }
  );
};

export const addChecklistMastersListApi = async (data) => {
  return await api.post(`/checklist/create`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const deleteChecklistMastersListApi = async (id) => {
  return await api.delete(`/checklist/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const updateChecklistMastersListApi = async (data) => {
  return await api.put(`/checklist/update/${data?.id}`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const updateQuetionChecklistMastersListApi = async (data) => {
  return await api.put(`/checklist-question/update/${data?.id}`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const getQuetionChecklistMastersListApi = async (id) => {
  return await api.get(`/checklist-question/checklist/${id}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const getAllQuetionChecklistMastersListApi = async (data) => {
  return await api.get(
    `/checklist-question-master/get-question-by-where?ChecklistId=${data?.ChecklistId}&DepartmentId=${data?.DepartmentId}`,
    {
      headers: {
        Authorization: `Bearer ${getCookie(TOKEN)}`,
      },
    }
  );
};

export const addQuetionChecklistMastersListApi = async (data) => {
  return await api.post(`/checklist-question/create`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

// Checklist Type Master API

export const getChecklistTypeMastersListApi = async (data) => {
  return await api.get(
    `/checklist-type/list?${data?.limit ? `&limit=${data?.limit}` : ""}${
      data?.offset.toString() ? `&offset=${data?.offset}` : ""
    }`,
    {
      headers: {
        Authorization: `Bearer ${getCookie(TOKEN)}`,
      },
    }
  );
};

export const addChecklistTypeMastersListApi = async (data) => {
  return await api.post(`/checklist-type/create`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const deleteChecklistTypeMastersListApi = async (id) => {
  return await api.delete(`/checklist-type/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const updateChecklistTypeMastersListApi = async (data) => {
  return await api.put(`/checklist-type/update/${data?.id}`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

// Role Master keys

export const getRoleMastersListApi = async () => {
  return await api.get(`/role/list`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const addRoleMastersListApi = async (data) => {
  return await api.post(`/role/create`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const deleteRoleMastersListApi = async (id) => {
  return await api.delete(`/role/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const updateRoleMastersListApi = async (data) => {
  return await api.put(`/role/update/${data?.id}`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

// Screen Access Master API

export const getScreenAccessMastersListApi = async () => {
  return await api.get(`/screen-access/list`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const addScreenAccessMastersListApi = async (data) => {
  return await api.post(`/screen-access/create`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const updateScreenAccessMastersListApi = async (data) => {
  return await api.put(`/screen-access/update/${data?.id}`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const deleteScreenAccessMastersListApi = async (id) => {
  return await api.delete(`/screen-access/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

// Role Permission Master API

export const getRolePermissionMastersListApi = async (data) => {
  return await api.get(`/user-screen-permission/role/${data?.id}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const addRolePermissionMastersListApi = async (data) => {
  return await api.post(`/user-screen-permission/create`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const deleteRolePermissionMastersListApi = async (id) => {
  return await api.delete(`/user-screen-permission/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const updateRolePermissionMastersListApi = async (data) => {
  return await api.put(`/user-screen-permission/update/${data?.id}`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

// Company API

export const getCompanyListApi = async (data) => {
  return await api.get(`/company/${data?.id}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

// User Master API (Company Admin Master,Management Master,Vessel Admin Master,Superintendent Master)

export const getUserMasterListApi = async (data) => {
  return await api.get(
    `/user/company/role?roleId=${data?.roleId}&companyId=${
      data?.companyId
    }&active=${data?.active}&searchByVesselId=${
      data?.searchByVesselId
    }&searchByFirstName=${data?.searchByFirstName}${
      data?.limit ? `&limit=${data?.limit}` : ""
    }${data?.offset.toString() ? `&offset=${data?.offset}` : ""}`,
    {
      headers: {
        Authorization: `Bearer ${getCookie(TOKEN)}`,
      },
    }
  );
};

export const addUserMasterListApi = async (data) => {
  return await api.post(`/user/create`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const deleteUserMasterListApi = async (id) => {
  return await api.delete(`/user/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const updateUserMasterListApi = async (data) => {
  return await api.put(`/user/update/${data?.id}`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

// Department Master API

export const getDepartmentMastersListApi = async (data) => {
  return await api.get(`/department/list?company_id=${data?.companyId}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const addNewDepartMentAPI = async (data) => {
  return await api.post(`/department/create`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const deleteDepartMentAPI = async (id) => {
  return await api.delete(`/department/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const updateDepartmentMastersListApi = async (data) => {
  return await api.put(`/department/update/${data?.id}`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

// Checklist Question  Master API

export const getQuetionChecklistMasterApi = async (data) => {
  return await api.get(
    `/checklist-question-master/list?company_id=${
      data?.company_id
    }&checklist_type=${data?.checklist_type}&active=${
      data?.active
    }&department_id=${data?.department_id}&searchByQuestion=${
      data?.searchByQuestion
    }${data?.limit ? `&limit=${data?.limit}` : ""}${
      data?.offset.toString() ? `&offset=${data?.offset}` : ""
    }`,
    {
      headers: {
        Authorization: `Bearer ${getCookie(TOKEN)}`,
      },
    }
  );
};

export const addQuestionMastersListApi = async (data) => {
  return await api.post(`/checklist-question-master/create`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const updateQuestionMastersListApi = async (data) => {
  return await api.put(`/checklist-question-master/update/${data?.id}`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const deleteChecklistQuestionAPI = async (id) => {
  return await api.delete(`/checklist-question-master/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

// Send Notification Master keys

export const getSendNotificationMastersListApi = async () => {
  return await api.get(`/notification/admin-list`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const addSendNotificationMastersListApi = async (data) => {
  return await api.post(`/notification/create`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

// Support Master keys

export const getSupportMastersListApi = async () => {
  return await api.get(`/user/contact-us/list`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};
